// @/constants/teamData.ts

// Define the structure for a single team member
export interface TeamMember {
    name: string;
    title: string;
    linkedinUrl: string;
    // The image should be placed in the public/team/ folder
    // and you only need to provide the filename here.
    image: string;
}

// =================================================================
// EDIT THIS LIST TO ADD, REMOVE, OR MODIFY TEAM MEMBERS
// =================================================================
export const teamMembers: TeamMember[] = [
    {
        name: "Adel Ahram",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/in/adel-ahram/",
        image: "adel_ahram.png",
    },
    {
        name: "Hamza Haque",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/in/hamzahaque/",
        image: "hamza_haque.jpeg",
    },
    {
        name: "Imane Amine",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "imane-amine.jpg",
    },
    {
        name: "Yassin",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "yassin.jpg",
    },
    {
        name: "Abdul Malik",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/in/aolumoh/",
        image: "abdul-malik.jpg",
    },
    {
        name: "Doha Bayoumy",
        title: "UX Designer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "doha-bayoumy.jpg",
    },
    {
        name: "Haniya",
        title: "UX Designer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "haniya.jpg",
    },
    {
        name: "Hassan",
        title: "UI/UX Designer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "hassan.jpg",
    },
    {
        name: "Kareem",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "kareem.jpg",
    },
    {
        name: "Mujtaba",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "mujtaba.jpg",
    },
    {
        name: "Rushan",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "rushan.jpg",
    },
    {
        name: "Shadab",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "shadab.jpg",
    },
    {
        name: "Shameer",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/",
        image: "shameer.jpg",
    },
    {
        name: "Shamin",
        title: "Software Engineer",
        linkedinUrl: "https://www.linkedin.com/in/shamin-yasar-768a322a5",
        image: "shamin_yasar.jpeg",
    },
];
